import React, { useRef } from 'react';

import { KGLogo, VirtuLogo } from '../../../components/Images';
import CalcHeight from '../CalcHeight';
import Link from '../../../components/Link';
import Text from '../../../components/Text';
import Center from '../../../components/Center';
import Media from '../../../components/Background';

import style from './style.module.css';

export default function Header() {
    const headline = "Taxi Insurance Data";
    const headerRef = useRef(null);
    return (
        <>
            <div className={style.header} ref={headerRef}>
                <Center>
                    <div className={style.headerWrap}>
                        <div className={`${style.headerLogo} ${style.para}`}>
                            <Link to={"/"} className={style.virtuLogo}>
                                <Media src={VirtuLogo} normalImage description="Virtu" title="Virtu" />
                            </Link>
                            <Text className={style.headline} text={headline} />
                        </div>
                        <div>
                            <Media src={KGLogo} normalImage />
                        </div>
                    </div>
                </Center>
            </div>
            <CalcHeight headerRef={headerRef} />
        </>
    )
}